import React from 'react';
import { bool, func, node, oneOf, string, oneOfType } from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Typography } from '@ajaibid/components';
import { ButtonV2 } from 'Component/Ajaib';

import { noop } from '@ajaibid/utils';
import { styPopUpDialog, styModal } from './style';

const PopupDialog = ({
  children,
  align,
  className,
  display,
  icon,
  image,
  subtitle,
  title,
  onHide,
  disabledPrimaryAction,
  onActionPrimaryClick,
  actionPrimaryText,
  disabledSecondaryAction,
  onActionSecondaryClick,
  actionSecondaryText,
  variantPrimary,
  variantSecondary,
  ...rest
}) => {
  const exist2Btn = Boolean(actionPrimaryText && actionSecondaryText);
  const half = {
    width: '49%',
  };
  const getButtonWidth = () => (exist2Btn ? half : {});
  return (
    <Modal
      show={display}
      size="lg"
      centered
      onHide={onHide}
      dialogClassName={`${styModal()} ${className}`}
      {...rest}
    >
      {title || subtitle ? (
        <div className={styPopUpDialog}>
          {icon && <img src={icon} width="60px" alt="iconPopup" />}
          {title && (
            <Typography type="section" bold align={align} data-testid="txtDialogTitle">
              {title}
            </Typography>
          )}
          {image && <img src={image} height="145px" alt="imgPopup" />}
          {subtitle && (
            <Typography
              type="body"
              style={{ marginTop: title ? '24px' : 0 }}
              align={align}
              data-testid="txtDialogSubtitle"
            >
              {subtitle}
            </Typography>
          )}
          <div style={{ display: 'flex', marginTop: '24px' }}>
            {actionSecondaryText && (
              <ButtonV2
                variant={variantSecondary}
                onClick={onActionSecondaryClick}
                fluid
                disabled={disabledSecondaryAction}
                data-testid="btnSecondary"
                {...getButtonWidth()}
              >
                {actionSecondaryText}
              </ButtonV2>
            )}
            {exist2Btn && <div style={{ margin: '8px' }} />}
            {actionPrimaryText && (
              <ButtonV2
                variant={variantPrimary}
                onClick={onActionPrimaryClick}
                fluid
                disabled={disabledPrimaryAction}
                data-testid="btnPrimary"
                {...getButtonWidth()}
              >
                {actionPrimaryText}
              </ButtonV2>
            )}
          </div>
        </div>
      ) : (
        children
      )}
    </Modal>
  );
};

PopupDialog.propTypes = {
  actionPrimaryText: oneOfType([string, node]),
  actionSecondaryText: oneOfType([string, node]),
  align: oneOf(['left', 'center', 'right', 'justify']),
  children: node,
  className: string,
  disabledPrimaryAction: bool,
  disabledSecondaryAction: bool,
  display: bool,
  icon: string,
  image: string,
  onActionPrimaryClick: func,
  onActionSecondaryClick: func,
  onHide: func,
  subtitle: string,
  title: string,
  variantPrimary: string,
  variantSecondary: string,
};

PopupDialog.defaultProps = {
  actionPrimaryText: '',
  actionSecondaryText: '',
  align: 'left',
  children: null,
  className: '',
  disabledPrimaryAction: false,
  disabledSecondaryAction: false,
  display: false,
  icon: '',
  image: '',
  onActionPrimaryClick: noop,
  onActionSecondaryClick: noop,
  onHide: noop,
  subtitle: '',
  title: '',
  variantPrimary: 'primary',
  variantSecondary: 'secondary',
};

export default PopupDialog;
